export const KANBAN_WHATSAPP_CONTACT_OPTIONS = [
  {
    label: 'Solicitante',
    name: 'requester',
  },
  {
    label: 'Proprietário',
    name: 'propertyOwner',
  },
  {
    label: 'Prestador',
    name: 'tradesman',
  },
]

export const KANBAN_ACTIONS_SYSTEM_PARAM_NAME = 'kanban_column_actions'
